import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { generateAccessCode } from "../../actions/farm";
import { Icon } from "../widgets";

const FarmAccessPopover = (props) => {
  const dispatch = useDispatch();
  const { farmAccessCode, farmUuid } = props;

  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClose = () => {
    setShow(false);
    setShowConfirm(false);
  };
  const generateCode = (farmId) => dispatch(generateAccessCode(farmId));

  const getPopover = (props) => (
    <Popover>
      <Popover.Title as="h4">
        <span>Access Code</span>
        <Button
          style={{ position: "relative", top: "-6px", right: "-10px" }}
          variant="danger"
          className="float-right btn-sm"
          onClick={() => handleClose()}
        >
          <Icon className="fa fa-times cursor-pointer" />
        </Button>
      </Popover.Title>
      <Popover.Content className="py-3 px-3">
        <label className="text-secondary farm-access-code">{props}</label>
        <CopyToClipboard text={props}>
          <Button variant="light">
            <i className="fa fa-clone" title="Copy" />
          </Button>
        </CopyToClipboard>
        <Button variant="light" onClick={() => setShowConfirm(true)}>
          <i className="fa fa-refresh cursor-pointer" title="Reset" />
        </Button>
      </Popover.Content>
    </Popover>
  );

  const handleConfirm = () => (
    <Popover>
      <Popover.Title as="h6">
        <span>Are you sure to reset farm pin? </span>
      </Popover.Title>
      <Popover.Content className="py-3 px-3">
        <Button
          className="col-5 mx-2"
          variant="primary"
          onClick={(e) => generateCode(farmUuid)}
        >
          Yes
        </Button>
        <Button
          className="col-5 ml-1"
          variant="danger"
          onClick={(e) => setShowConfirm(false)}
        >
          No
        </Button>
      </Popover.Content>
    </Popover>
  );
  return farmAccessCode ? (
    <>
      <OverlayTrigger
        show={show}
        onToggle={(toggle) => setShow(toggle)}
        trigger="click"
        placement="left"
        overlay={getPopover(farmAccessCode)}
      >
        <i
          className="fa fa-lock cursor-pointer"
          style={{ opacity: showConfirm ? 0 : 1 }}
          title="Show access code"
        />
      </OverlayTrigger>

      {showConfirm && (
        <OverlayTrigger
          show={showConfirm}
          onToggle={(toggle) => setShowConfirm(toggle)}
          trigger="click"
          placement="right"
          overlay={handleConfirm()}
        >
          <i className="fa fa-lock cursor-pointer" title="Show access code" />
        </OverlayTrigger>
      )}
    </>
  ) : (
    <i className="fa fa-lock cursor-pointer" title="Access code not assigned" />
  );
};

export default FarmAccessPopover;
